import {Component, inject, OnInit, signal, ViewChild} from '@angular/core';
import {CustomErrorComponent} from '../../../shared/custom-error.component';
import {FormsModule, NgForm, ReactiveFormsModule} from '@angular/forms';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {ConfirmDialogService} from '../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {emailPattern, SsoUser, updateFormAndValidity} from '../../../app.constants';
import {UserOfficialDto, UserType} from '../../../../generated-model/model';
import {filter} from 'rxjs/operators';
import {UserRest} from '../../../service/UserRest';
import {ToastService} from '../../../shared/commons/toast/toast-service';

@Component({
  selector: 'app-manage-user-sso-modal',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    NgStyle,
    CustomErrorComponent,
    NgIf,
  ],
  templateUrl: './manage-official-user-modal.component.html',
  styleUrl: './manage-official-user-modal.component.scss'
})
export class ManageOfficialUserModalComponent{
  @ViewChild('form') form: NgForm

  prefix = ''
  confirmDialogService = inject(ConfirmDialogService)
  public activeModal = inject(NgbActiveModal);
  userOfficialDto = signal<UserOfficialDto>({})
  userService = inject(UserRest)
  toastService = inject(ToastService)
  disable = signal(false)
  userData = signal<SsoUser>(undefined)


  save() {
    let valid = updateFormAndValidity(this.form);
    if (!valid) {
      this.toastService.showWarning('กรุณากรอกข้อมูลให้ครบถ้วน');
    } else {
      this.confirmDialogService.open({content: 'ยืนยันการบันทึกข้อมูล'}).pipe(filter(e => !!e))
        .subscribe({
          next: () => {

            const operation = !this.userOfficialDto().id
              ? this.userService.saveOfficialUser(this.userOfficialDto())
              : this.userService.editUserOfficial(this.userOfficialDto());

            operation.subscribe({
              next: () => {
                this.activeModal.close(true);
                this.toastService.showSuccess('บันทึกข้อมูลสำเร็จ');
              },
              error: (error) => {
                // แสดงข้อความผิดพลาดที่ได้รับจาก API
                const errorMessage = error?.error?.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
                this.toastService.showDangerWithMessage(errorMessage);
              },
            });
          }
        });
    }
  }

  protected readonly emailPattern = emailPattern;
  protected readonly UserType = UserType;
  }
